
WB.Modules = WB.Modules || {};
WB.Modules.HomepageCurrentDirectiveLink = function(PageLayoutsDataManager) {
    return function (scope, element, attr, baseCtrl) {
        scope.$root.RouteLoader = 'Homepage';
        baseCtrl.clearError();

        // We don't update the page layout based on location, because
        // that responsibility is left to the individual widgets
        PageLayoutsDataManager
            .GetPageLayoutForAlias('Forecasts-Current')
            .then(function(layout) {
                scope.layout = layout;
            })
            .catch(function(err) {
                baseCtrl.error(err);
            })
            .finally(function() {
                scope.$root.RouteLoader = null;
            });

        scope.$on('$destroy', function() {
            baseCtrl.clearError();
        });
    };
};

WB.Modules.HomepageCurrentDirective = function(PageLayoutsDataManager) {
    return {
        scope: {
            location: '='
        },
        restrict: 'AE',
        require: '^wbModuleHomepage',
        link: WB.Modules.HomepageCurrentDirectiveLink(PageLayoutsDataManager),
        template: `<div class="forecasts__ad"
        ng-if="$root.isBreakpointSmall">
        <display-ad-widget slotId="'forecasts/current_x83'" width="320" height="50" />
    </div>

    <div class="forecasts-subtab"
        ng-class="forecasts-subtab--current">
        <div class="container forecasts-container">
            <div class="forecasts-subtab-wrap">
                <div wb-widget-grid grid="layout.WidgetGrids[0]"></div>
            </div>
        </div>
    </div>`
    };
};
WB.Modules.HomepageCurrentDirective.$inject = ['PageLayoutsDataManager'];

WB.App.directive('wbModuleHomepageCurrent', WB.Modules.HomepageCurrentDirective);
